import { GraphQLError } from 'graphql';

type ErrorExtensions = Record<string, unknown>;

export class ApolloError extends GraphQLError {
  constructor(message: string, code = 'INTERNAL_SERVER_ERROR', extensions: ErrorExtensions = {}) {
    // Use positional args for compatibility with GraphQL v15 and v16.
    super(message, undefined, undefined, undefined, undefined, undefined, {
      code,
      ...extensions,
    });
  }
}

export class AuthenticationError extends ApolloError {
  constructor(message = 'Authentication failed', extensions: ErrorExtensions = {}) {
    super(message, 'UNAUTHENTICATED', extensions);
  }
}
